module.exports = __webpack_public_path__ + "assets/img/gestion_electronique_documents_securite.025454c1.jpg";